import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  FormControlLabel,
  IconButton,
  Switch,
  useMediaQuery,
} from "@mui/material";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { useMemo } from "react";
import Button from "@mui/material/Button";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { blue } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { useTheme } from "@material-ui/core/styles";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { GridToolbarFilterButton } from "@mui/x-data-grid";
import { useGridFilter } from "@mui/x-data-grid/internals";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useRef } from "react";
import { DataArrayOutlined } from "@mui/icons-material";
import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "../firebase";
import { useNavigate } from "react-router-dom/dist";

const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#E8EAF6",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
});

function Report() {

  const [rows, setRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState(false);
  const [viewForm, setViewForm] = useState({});

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "reports");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);

  const filteredRows = rows.filter((row) => {
    return searchTerm.toLowerCase() === ""
      ? row
      : row.subject.toLowerCase().includes(searchTerm) ||
          row.date.toString().toLowerCase().includes(searchTerm) ||
          row.user.toLowerCase().includes(searchTerm) ||
          row.amount.toLowerCase().includes(searchTerm) ||
          row.description.toLowerCase().includes(searchTerm);
  });

  console.log(filteredRows);

  const getTotalAmountByStatus = (subject) => {
    return filteredRows.reduce((total, item) => {
      if (item.subject === subject) {
        return total + Number(item.amount);
      }
      return total;
    }, 0);
  };

  const totalExpense = getTotalAmountByStatus("Expense");
  const totalIncome = getTotalAmountByStatus("Income");

  const columns = useMemo(
    () => [
      {
        field: "date",
        headerName: "DATE",
        width: 100,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "subject",
        headerName: "SUBJECT",
        width: 130,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "description",
        headerName: "DESCRIPTION",
        width: 300,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "user",
        headerName: "USER",
        width: 150,
        headerClassName: "super-app-theme--header",
      },
      {
        field: "amount",
        headerName: "AMOUNT",
        width: 100,
        headerClassName: "super-app-theme--header",
      },
      //   {
      //     field: "status",
      //     headerName: "STATUS",
      //     type: "boolean",
      //     width: 80,
      //     headerClassName: "super-app-theme--header",
      //     renderCell: (params) => <Toggle params={params} />,
      //   },
      {
        field: "actions",
        headerName: "ACTIONS",
        type: "actions",
        renderCell: (params) => <Actions params={params} />,
        width: 120,
        headerClassName: "super-app-theme--header",
      },
    ],
    []
  );

  const handleViewClose = () => {
    setView(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setVisible(true);
  };

  const handleReset = () => {
    setSearchTerm("");
    setVisible(false);
  };

  const ViewDialog = (params) => {
    return (
      <div className="view-card">
        <div className="close">
          <IconButton aria-label="delete" onClick={handleViewClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="view">
          <label htmlFor="name">Date</label>
          <span>:</span>
          <span className="data">{viewForm.date}</span>
          <label htmlFor="email">Subject</label>
          <span>:</span>
          <span className="data">{viewForm.subject}</span>
          <label htmlFor="phone">Amount</label>
          <span>:</span>
          <span className="data">{viewForm.amount}</span>
          <label htmlFor="position">User</label>
          <span>:</span>
          <span className="data">{viewForm.user}</span>
          <label htmlFor="des">Description</label>
          <span>:</span>
          <span className="data">{viewForm.description}</span>
          {/* <label htmlFor="status">Status</label>
            <span>:</span>
            <span>{viewForm.sta}</span> */}
        </div>
      </div>
    );
  };

  const Actions = (params) => {
    return (
      <div className="action-buttons">
        <IconButton
          aria-label="delete"
          onClick={() => {
            setView(true);
            console.log(params.params.row);
            setViewForm(params.params.row);
          }}
        >
          <VisibilityIcon />
        </IconButton>
      </div>
    );
  };

  return (
    <div
      className="list"
      style={{ height: "90vh", width: "900px", padding: "10px" }}
    >
      <div className="head" style={{ height: "10vh", width: "100%" }}>
        <SearchIcon className="search-icon" />
        <input
          id="search"
          type="text"
          value={searchTerm}
          placeholder="Search..."
          onChange={handleSearch}
        />
        {visible && (
          <IconButton
            className="reset"
            aria-label="delete"
            onClick={handleReset}
          >
            <RestartAltIcon />
          </IconButton>
        )}
        <div style={{ position: "relative",top: "-30px", left: "580px" }}>
          <span style={{ color: "green" }}>Total Income : </span>
          <span style={{ position: "relative", top: "1px" }}>
            {totalIncome}
          </span>
          &ensp;
          <span style={{ color: "red" }}>Total Expense : </span>
          <span style={{ position: "relative", top: "1px" }}>
            {totalExpense}
          </span>
        </div>
      </div>
      <div
        className="table"
        style={{ height: "70vh", width: "100%", overflow: "auto" }}
      >
        {view && <ViewDialog />}
        <DataGrid
          rows={filteredRows}
          columns={columns}
          disableRowSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          getRowId={(row) => row.id}
          // components={{
          //   Toolbar: GridToolbar,
          // }}
          // components={{
          //   Toolbar: CustomToolbar,
          // }}
          // editMode="cell"
          // onCellEditCommit={handleCellEditCommit}
          sx={{
            "& .super-app-theme--header": {
              background: "rgb(211, 232, 239)",
              color: "black",
              fontWeight: "900",
              fontSize: "15px",
              fontFamily:
                "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
            },
            "& .MuiDataGrid-columnHeaderCheckbox": {
              background: "rgb(211, 232, 239)",
            },
            overflow: "hidden",
          }}
        />
      </div>
    </div>
  );
}

export default Report;
